import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import { useEffect } from 'react';

import { useDeleteMemberTypeMutation } from 'store/api/version-api.slice';

import { billingTypeDisplay, renewalTypeDisplay } from '../helpers';

const MemberTypeItem = ({ item, setEditableMemberType, setIsEditOpen, setShowOverlay }) => {
	const [deleteMemberType, { isLoading: isLoadingDelete }] = useDeleteMemberTypeMutation();

	const onEditMemberType = () => {
		setEditableMemberType(item);
		setIsEditOpen(true);
	};

	const onDeleteMemberType = () => {
		deleteMemberType(item.id);
	};

	useEffect(() => {
		setShowOverlay(isLoadingDelete);
	}, [isLoadingDelete, setShowOverlay]);

	return (
		<ListItem>
			<ListItemText
				primary={item.member_type}
				secondary={`${billingTypeDisplay(item.billing)} - ${renewalTypeDisplay(item.renewal)} - $${
					item.amount
				}`}
			/>
			<ListItemSecondaryAction>
				<IconButton edge="end" aria-label="delete" onClick={onEditMemberType}>
					<EditIcon />
				</IconButton>
				<IconButton edge="end" aria-label="delete" onClick={onDeleteMemberType}>
					{isLoadingDelete ? <CircularProgress size={20} /> : <CloseIcon />}
				</IconButton>
			</ListItemSecondaryAction>
			<Divider />
		</ListItem>
	);
};

export default MemberTypeItem;
